export default {
  en: {
    BULK_BLOCKED_TAB_DESCRIPTION: 'Numbers can be blocked in bulk by uploading a file containing the numbers you wish to block. The numbers uploaded via this tab WON\'T show up in the individual blocked numbers list, use the search box to verify the status of a number, and if necessary, remove it from the bulk blocked list.',
    SEARCH_BULK_BLOCKED_NUMBERS_HEADER: 'Search Number in Blocked List',
    UNBLOCK_NUMBER: 'Unblock',
    VALID_NUMBERS: 'Valid Numbers',
    INVALID_NUMBERS: 'Invalid Numbers',
    NUMBERS_LIST_EMPTY: '---- No Numbers ----',
    BLOCK_CHECK_NUMBER_INPUT: 'Number to Check',
    BLOCK_CHECK_NUMBER_INPUT_TT: 'The number you want to search in your blocked list (E.164 format)',
    BLOCK_CHECK_BLOCK_TYPE_INPUT: 'Block Type',
    BLOCK_CHECK_BLOCK_TYPE_INPUT_TT: 'Select if you want to search the bulk blocked number at account level or at campaign level',
    BLOCK_CHECK_CAMPAGIN_ID_INPUT: 'Campaign ID',
    BLOCK_CHECK_CAMPAGIN_ID_INPUT_TT: 'ID of the campaign you want to check if the number has been blocked for',
    BLOCK_CHECK_BUTTON: 'Search',
    BLOCK_NUMBERS_UPLOAD_INPUT: 'Numbers To Block',
    BLOCK_NUMBERS_UPLOAD_INPUT_TT: 'CSV or TXT file containing the numbers you want to block in E164 format',
    BLOCK_NUMBERS_BLOCK_TYPE_INPUT: 'Block Type',
    BLOCK_NUMBERS_BLOCK_TYPE_INPUT_TT: 'Select if you want to bulk block the numbers at account level or at campaign level',
    BLOCK_NUMBERS_CAMPAGIN_ID_INPUT: 'Campaign',
    BLOCK_NUMBERS_CAMPAGIN_ID_INPUT_TT: 'Campaign you want to block the numbers for',
    BLOCK_NUMBERS_BUTTON_SAVE: 'Bulk Block Numbers',
    NO_VALID_PHONES_ERROR: 'The file does not contain any valid phone number to block',
    NO_FILE: 'Please upload a file with the numbers to block',
    ITEMS_AMOUNT: '({amount} items)',
    BLOCK_CHECK_RESULT: 'Search Result',
    BLOCK_CHECK_RESULT_TT: 'Results of the search',
    CHECK_NUMBER_BULK_BLOCKED_RESULT_PLACEHOLDER: 'Enter number to search',
    CHECK_NUMBER_BULK_BLOCKED: 'Checking aganist bulk list',
    BULK_BLOCKED_SEARCH_MODAL_TITLE_NOT_BLOCKED: 'Search Result: {number} is Not Blocked',
    BULK_BLOCKED_SEARCH_MODAL_TITLE_BLOCKED: 'Search Result: {number} is Blocked',
    BULK_BLOCKED_NUMBER_SEARCH_RESULT_NOT_FOUND: '{number} Is NOT in any block lists',
    BULK_BLOCKED_NUMBER_SEARCH_RESULT_ACCOUNT_LEVEL: '{number} Is blocked at account level',
    BULK_BLOCKED_NUMBER_SEARCH_RESULT_CAMPAIGN_LEVEL: '{number} Is blocked in the following Campaign bulk block lists',
    BLOCK_NUMBER_EXPLANATION: 'To block this number use the "Individual Blocked Numbers" tab or upload a TXT or CSV file with this number in the "Bulk Block Numbers" tab.',
    BULK_SEARCH_LOADING: 'Searching number in blocked lists',
    UNBLOCK_SUCCESS: 'Successfully removed number from bulk list',
    BULK_BLOCK_SUCESS: 'Successfully blocked numbers',
    FILE_TOO_BIG_ERROR_TITLE: 'Upload Failed',
    FILE_TOO_BIG_ERROR: 'The file you are trying to upload is too big, please split it into files smaller than 1MB.',
    FILE_MAXIMUM_SIZE: 'Maximum size is 1 MB',
  }
};